var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bg-purple" }, [
    _c("div", { staticClass: "stars" }, [
      _c("div", { staticClass: "central-body" }, [
        _c("span", { staticClass: "code" }, [_vm._v("404")]),
        _vm._v(" "),
        _c("span", { staticClass: "message" }, [
          _vm._v("Ops! A página não foi encontrada.")
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "btn-go-home",
            attrs: { href: "#", title: "Ir para a home" },
            on: {
              click: function($event) {
                return _vm.goToDashboard()
              }
            }
          },
          [
            _vm._v("\n        Ir para a home\n        "),
            _c("img", {
              attrs: {
                src: "/static/resources/images/rocket.svg",
                width: "25px"
              }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "objects" }, [
      _c("img", {
        staticClass: "object_rocket",
        attrs: { src: "/static/resources/images/rocket.svg", width: "40px" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "earth-moon" }, [
        _c("img", {
          staticClass: "object_earth",
          attrs: { src: "/static/resources/images/earth.svg", width: "100px" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "object_moon",
          attrs: { src: "/static/resources/images/moon.svg", width: "80px" }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "box_astronaut" }, [
        _c("img", {
          staticClass: "object_astronaut",
          attrs: {
            src: "/static/resources/images/astronaut.svg",
            width: "140px"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "glowing_stars" }, [
      _c("div", { staticClass: "star" }),
      _vm._v(" "),
      _c("div", { staticClass: "star" }),
      _vm._v(" "),
      _c("div", { staticClass: "star" }),
      _vm._v(" "),
      _c("div", { staticClass: "star" }),
      _vm._v(" "),
      _c("div", { staticClass: "star" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61235a24", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61235a24","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Statics/404.vue
// module id = null
// module chunks = 